import { useEffect } from 'react';
import { ObjectIdString } from '../types/common';
import {
    identifyUserAndPage,
    PageName,
} from '../utils/locale/identifyUserAndPage';

export function useIdentifyUserAndPage(
    userId: ObjectIdString | undefined,
    pageName: PageName,
    userEmail: string | undefined,
) {
    useEffect(() => {
        if (!userId || !userEmail) {
            return;
        }

        identifyUserAndPage(userId, pageName, userEmail);
    }, [userId, pageName, userEmail]);
}
